exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.chat-group a:hover{\n    cursor:default;\n}\n", ""]);

// exports
